import { getElementOrLogError } from '../../utils/utils';
export class RenderSuccessWindow {
    constructor(template, events) {
        this.events = events;
        const content = template.content.cloneNode(true);
        this.success = getElementOrLogError('.order-success', content);
        this.description = getElementOrLogError('.order-success__description', this.success);
        this.button = getElementOrLogError('.order-success__close', this.success);
        this.initEventListeners();
    }
    initEventListeners() {
        this.button.addEventListener('click', () => this.events.emit('renderSuccessWindow:close'));
    }
    render(total) {
        this.description.textContent = `Списано ${total} синапсов`;
        return this.success;
    }
}
